
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scholarship/[eventKey]",
      function () {
        return require("private-next-pages/scholarship/[eventKey].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scholarship/[eventKey]"])
      });
    }
  